<template>
  <div>
    <div v-for="(rec, index) in rackInfoList" :key="index">
      <v-row no-gutters class="py-1">
        <v-col cols="2" class="pr-2">
          <NormalNumberInput v-model="rackInfoList[index].quantity" />
        </v-col>
        <v-col cols="4">
          <NormalDatePicker
            v-model="rackInfoList[index].shippingDate"
            locale="jp-ja"
            :day-format="(date) => new Date(date).getDate()"
            min="1950-01-01"
          ></NormalDatePicker>
        </v-col>
        <v-col cols="4">
          <NormalDatePicker
            v-model="rackInfoList[index].deliveryDate"
            locale="jp-ja"
            :day-format="(date) => new Date(date).getDate()"
            min="1950-01-01"
          ></NormalDatePicker>
        </v-col>
        <v-col cols="2">
          <v-btn v-if="index === 0" icon class="pb-1" @click="onClick(index)">
            <v-icon>{{ 'mdi-plus-circle-outline' }}</v-icon>
          </v-btn>
          <v-btn v-else icon class="pb-1" @click="removeRackItem(index)">
            <v-icon>{{ 'mdi-close-circle-outline' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import NormalNumberInput from '@/components/items/inputs/NormalNumberInput'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'

export default {
  name: 'QuantityDate',
  components: {
    NormalDatePicker,
    NormalNumberInput
  },
  data: () => ({
    rackInfoList: [
      {
        quantity: '',
        shippingDate: '',
        deliveryDate: ''
      }
    ]
  }),
  props: {
    rackNumberList: {
      type: Array,
      require: true,
      default: () => []
    },
    defaultQuantity: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.rackInfoList[0].quantity = this.defaultQuantity
  },
  methods: {
    onClick(idx) {
      this.rackInfoList.splice(idx + 1, 0, {
        quantity: 0,
        shippingDate: '',
        deliveryDate: ''
      })
    },
    removeRackItem(idx) {
      this.rackInfoList.splice(idx, 1)
    }
  },
  watch: {
    rackInfoList: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    },
    defaultQuantity: function (newVal, oldVal) {
      this.rackInfoList[0].quantity = newVal
    }
  }
}
</script>
<style scoped lang="scss"></style>
